import { useMemo } from "react"
import { resolveSceneDefinition } from "@geoflow/benchmap"

// Modell (roher GeoServer-Workspace) + Legenden-URL des aktiven Farb-Layers;
// folgt auch dem Mean/Gusts-Wechsel
export function useWeatherSceneInfo(controller) {
  return useMemo(() => {
    if (!controller.definition) return { activeModel: null, legendUrl: null }
    const { layers, matches } = resolveSceneDefinition(
      controller.definition,
      controller.selectorState,
      controller.catalogLayers,
    )
    const colorMatch = matches.find((match) =>
      layers.some(
        (layer) => layer.id === match.intentKey && layer.role === "color",
      ),
    )

    // Erster Match mit showLegend-Layer; URL-Aufbau wie benchmaps getLegendGraphicJsonUrl (nicht exportiert)
    let legendMatch = null
    let legendLayer = null
    for (const match of matches) {
      const resolved = layers.find((layer) => layer.id === match.intentKey)
      if (resolved?.showLegend && match.matchedLayer) {
        legendMatch = match
        legendLayer = resolved
        break
      }
    }
    let url = null
    if (legendMatch) {
      const u = new URL(
        `${controller.geoserverUrl}/${legendMatch.matchedLayer.model}/wms`,
        window.location.origin,
      )
      u.searchParams.append("REQUEST", "GetLegendGraphic")
      u.searchParams.append("FORMAT", "application/json")
      u.searchParams.append("LAYER", legendMatch.matchedLayer.layer)
      u.searchParams.append(
        "STYLE",
        legendLayer.style ?? legendMatch.matchedLayer.defaultStyle ?? "",
      )
      u.searchParams.append("WIDTH", "20")
      u.searchParams.append("HEIGHT", "1")
      url = u.toString()
    }

    return {
      activeModel: colorMatch?.matchedLayer?.model ?? null,
      legendUrl: url,
    }
  }, [
    controller.definition,
    controller.selectorState,
    controller.catalogLayers,
    controller.geoserverUrl,
  ])
}
